import { Component, Input, ViewEncapsulation, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { LoaderComponent } from '@components/layouts/loader/loader.component';
import { SignService } from '@services/sign.service';
import { IGetSignerSignature } from '@modals/api.modal';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'kzn-upload-sign-recent-uploads',
  standalone: true,
  imports: [MatRadioModule, MatCardModule, ReactiveFormsModule, LoaderComponent, TranslateModule],
  templateUrl: './upload-sign-recent-uploads.component.html',
  styleUrl: './upload-sign-recent-uploads.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class UploadSignRecentUploadsComponent {
  @Input() selfSignMode = false;
  recentUploadImgCtrl: FormControl = new FormControl({});
  onRecentUploadImageChange = output<{
    image: string,
    signatureId: string
  }>();

  constructor(public signService: SignService) { }

  onImageSelected() {
    this.onRecentUploadImageChange.emit({
      image: this.recentUploadImgCtrl.value.SignImagePath,
      signatureId: this.recentUploadImgCtrl.value.Id
    });
  }

  selectSignature(signature: IGetSignerSignature): void {
    this.recentUploadImgCtrl.setValue(signature);
    this.onImageSelected();
  }

  preselectSignature(signature: IGetSignerSignature): void {
    this.recentUploadImgCtrl.setValue(signature);
  }

  resetRecentUpload() {
    this.recentUploadImgCtrl.reset();
  }
}
